module.exports = __webpack_public_path__ + "static/media/fragrances-deos.aaa408ae.jpeg";